// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__Q1cIS","title":"card_title__3z821","inActive":"card_inActive__1Iqz-"};